import React, { useState, useEffect } from "react";
import { Box, Typography, Grid2 } from "@mui/material";
import ViewEditUser from "./ViewEditUser";
import CreateUser from "./CreateUser";
import UserList from "./UserList";
import ActionButtonsPane from "./ActionButtonsPane";

const Users = ({
  mode,
  setMode,
  initialUsers,
  selectedUser,
  setSelectedUser,
  updateUser,
  addUser = () => {} ,
  actions = [],
  typeIsActive = false,
  deletedStatusIsActive = false,
  activeStatusIsActive = false,
  isSuperuser = false,
  multiselect = false,
  createUser,
  restoreUser,
  selectOrAddMessage,
  userIsEditable
}) => {
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

  useEffect(() => {
    if (Array.isArray(initialUsers)) {
      setUsers(initialUsers);
    }
  }, [initialUsers]);

  useEffect(() => {
    if (selectedUser) {
      setMode("view");
    } else if (mode === "view") {
      setMode("empty");
    }
  }, [selectedUser, setMode, mode]);

  const onUserCreated = (newUser) => {
    setUsers([...users, newUser]);
  }

  return (
    <Box p={3}>
      <Grid2 container spacing={2} justifyContent="center">

        <UserList
          users={users}
          multiselect={multiselect}
          typeIsActive={typeIsActive}
          deletedStatusIsActive={deletedStatusIsActive}
          activeStatusIsActive={activeStatusIsActive}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          handleSelectedUser={setSelectedUser}
          selectedUsers={selectedUsers}
          handleSelectedUsers={setSelectedUsers}
        />

        <Grid2>
          {mode === "view" && selectedUser ? (
            <ViewEditUser
              user={selectedUser}
              isSuperuser={isSuperuser}
              onSubmit={updateUser}
              onClose={() => setSelectedUser(null)}
              isEditable={userIsEditable} />
          ) : mode === "create" ? (
            <CreateUser
              typeIsActive={typeIsActive}
              onCreated={onUserCreated}
              isSuperuser={isSuperuser}
              onSubmit={createUser}
              onRestore={restoreUser}
              onCancel={() => setMode("empty")}
              onAdd={addUser}
            />
          ) : (
            <Box
              sx={{
                border: "2px dashed #b0b0b0",
                borderRadius: 2,
                height: "100%",
                width: 300,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "gray",
                bgcolor: "#fafafa",
              }}
            >
              <Typography variant="h6" color="text.secondary">
                {selectOrAddMessage}
              </Typography>
            </Box>
          )}
        </Grid2>

        <ActionButtonsPane
          actions={actions}
        />
      </Grid2>
    </Box>
  );
};

export default Users;
